import { DeraSubsectionLookup } from './dera-questions.interface';

// See dera-background.ts for the question/subsection format. Questions are stubbed pending final content.
export const DeraHealthSubsections: { [key: string]: DeraSubsectionLookup } = {
  disabilityHealthCondition: {
    displayValue: 'Disability / Health Condition',
    questions: {},
  },
  addictionSubstanceUse: {
    displayValue: 'Addiction and Substance Use',
    questions: {},
  },
};
